<template>
	<div>
		<header-pago />
		<section-information 
			message="TU TOKEN CADUCO"
			message-down="Comunicate con cualquiera de nuestros asesores de venta: "
		/>
	</div>
</template>
<script>
import headerPago from '@/components/pago/app-header';
import sectionInformation from '@/components/generate-app/section-information';

export default {
	name: 'section-expired',
	components: {
		sectionInformation,
		headerPago,
	},
};
</script>


// WEBPACK FOOTER //
// src/components/generate-app/section-expired.vue